import { render, staticRenderFns } from "./PageProducs.vue?vue&type=template&id=583e42cb&"
import script from "./PageProducs.vue?vue&type=script&lang=js&"
export * from "./PageProducs.vue?vue&type=script&lang=js&"
import style0 from "./PageProducs.vue?vue&type=style&index=0&id=583e42cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports